import { createUseStyles } from 'react-jss'

import { desktop } from '../../theme'


export default createUseStyles({
  container: {
    backgroundColor: 'white',
    paddingLeft: '2.8rem',
    paddingRight: '2.8rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100vw',
    minHeight: 'calc(var(--vh, 1vh) * 100)',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,
    height: '100%',
    width: '100%',
    '& > *:not(.is-notstaggered)': {
      opacity: 0, // to prevent FOUC
    },
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },
  countDown: {
    fontSize: '5rem',
    color: 'black',
    marginTop: 'auto',
    marginBottom: 'auto',
    ...desktop({
      fontSize: '8rem',
    }),
  },
})
